var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.875H10.625V12.5H9.375V6.875ZM8.125 1.25H11.875V2.5H8.125V1.25Z",
    fill: "#8898A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 5.62568L16.6124 4.74443L15.2062 6.15068C14.055 4.82133 12.436 3.98658 10.6854 3.81987C8.93486 3.65317 7.18736 4.16733 5.80602 5.25552C4.42468 6.34371 3.5157 7.92227 3.26794 9.66322C3.02018 11.4042 3.45269 13.1736 4.47561 14.604C5.49853 16.0343 7.0332 17.0156 8.76077 17.3439C10.4883 17.6722 12.276 17.3222 13.7523 16.3668C15.2285 15.4113 16.28 13.9239 16.6881 12.2134C17.0962 10.5029 16.8296 8.70096 15.9437 7.18193L17.4999 5.62568ZM9.9999 16.2507C8.88738 16.2507 7.79985 15.9208 6.87482 15.3027C5.94979 14.6846 5.22882 13.8061 4.80308 12.7783C4.37734 11.7504 4.26594 10.6194 4.48298 9.5283C4.70003 8.43716 5.23576 7.43488 6.02243 6.64821C6.8091 5.86154 7.81138 5.32581 8.90252 5.10876C9.99366 4.89172 11.1247 5.00312 12.1525 5.42886C13.1803 5.8546 14.0588 6.57557 14.6769 7.5006C15.295 8.42562 15.6249 9.51316 15.6249 10.6257C15.6249 12.1175 15.0323 13.5483 13.9774 14.6032C12.9225 15.658 11.4917 16.2507 9.9999 16.2507Z",
    fill: "#8898A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWatch);
export default __webpack_public_path__ + "static/media/ic-watch.9958aef1ccc8bad020c90a34695eabe2.svg";
export { ForwardRef as ReactComponent };